import { useContext } from "react";
import { useHistory, useParams } from "react-router-dom";

import { UserReportPrint } from "@/components/reports/print";
import { ViewerContext } from "@/tpo/Viewer";

import {
  WARD_USER_REPORT_PRINT_QUERY,
  WARD_USER_RESULT_PRINT_DETAILS_QUERY
} from "./graphql/printQueries";

export default function WardReportPrint() {
  const history = useHistory();
  const { reportSlug } = useParams();
  const { userId } = useContext(ViewerContext);

  const handleClose = () => {
    history.push(`/patients/${userId}/reports/${reportSlug}/overview`);
  };

  if (!userId) {
    return <div>Loading...</div>;
  }

  return (
    <UserReportPrint
      userId={userId}
      reportSlug={reportSlug}
      reportPrintQuery={WARD_USER_REPORT_PRINT_QUERY}
      userResultPrintDetailsQuery={WARD_USER_RESULT_PRINT_DETAILS_QUERY}
      onClose={handleClose}
    />
  );
}
